// @flow
import getMaximizedLocation from './getMaximizedLocation'
import buildSuggestionFromLocation from './builders/locationToSuggestion'

// Types
import type { SuggestionLocation, Location } from '../../models/location'
import type { Options } from './getSuggestions'

/**
 * Finds a suggestion by its value, fetches its geo-location
 * information as well.
 * @param  {string}   value the place's value in the database
 * @param  {Location} others some other fields you know about the location
 *                           you are looking for.
 * @return {Promise|Error} A resolved Promise with the place or
 *                         Rejected with an Error.
 */
export const getBestSuggestion = (
  value: string,
  others?: $Shape<Location>,
  biasCoordinates?: SuggestionLocation,
  otherParams?: Options
): Promise<SuggestionLocation> =>
  getMaximizedLocation(
    {
      name: '',
      customName: '',
      address: value,
      fullAddress: '',
      iataCode: '',
      country: '',
      notSpecific: false,
      timezone: '',
      placeId: '',
      airportName: '',
      isCruisePort: false,
      type: '',
      ...others,
    },
    biasCoordinates,
    otherParams
  ).then(buildSuggestionFromLocation)

export default getBestSuggestion
